import React from 'react';
import { Route, Router } from 'react-router-dom';
import { createBrowserHistory, createMemoryHistory } from 'history';
import { render } from '@testing-library/react';
import {
    ApplicationContext,
    ApplicationContextProvider,
    ApplicationState,
    ApplicationConfigContext,
    getDefaultBlankAppConfig,
    getDefaultInitialApplicationState
} from '../../store';
import { StandardAppConfig } from 'src/Components';
import { BaseRoute, ProfileConnectRoute } from '../utils';

type RouteType = typeof BaseRoute | typeof ProfileConnectRoute;

export type RoutesConfig = Record<Route, RouteInfo>;
export interface RouteInfo {
    route?: RouteType;
    sessionTimeoutEnabled?: boolean;
    usePoi?: boolean;
    path: string;
    component: any;//React.FC< {progressStepper?: any}>;
    exact?: boolean;
    title?: string;
    showConfirmOnClose?: string;
}
export type RoutePathsConfig = { routePath: RoutePath };

type RoutePath = string;

export type Route =
    // Routes included in progress stepper
    //| 'personalDetailsPage'
    //| 'contactDetailsPage'
    | 'eligibilityPage'
    | 'supportingDocumentsPage'
    | 'bankDetailsPage'
    | 'bankReviewPage'
    | 'ReviewPage'
    | 'confirmationPage'
    | 'errorPage'
    // Routes not included in progress stepper
    | 'homePage'
    | 'landingPage'
    | 'logoutRedirect'
    | 'authenticateRedirect'
    | 'profileRedirect'
    | 'profileRedirectSuccess'
    | 'profileConnectError'
    | 'profileConnectCancel'
    | 'poiRedirect'
    //| 'duplicate'
    ;

export const history = createBrowserHistory();

export function renderWithRouterMatch(ui,
    {
        path = '/', // ie. '/project/:id'
        route = '/', // ie. '/project/ABC123'
        history = createMemoryHistory({ initialEntries: [route] })
    } = {}) {
    return {
        ...render(
            <Router history={ history }>
                <Route path={ path } component={ ui } />
            </Router>
        )
    };
}

export function renderWithApplicationContext(ui,
    {
        path = '/', // ie. '/project/:id'
        route = '/', // ie. '/project/ABC123'
        history = createMemoryHistory({ initialEntries: [route] }),
    } = {},
    initialGlobalState?: ApplicationState,
    initialAppConfig?: StandardAppConfig) {
    return {
        ...render(
            <ApplicationConfigContext.Provider value={ initialAppConfig ?? getDefaultBlankAppConfig() }>
                <ApplicationContext.Provider
                    value={ {
                        globalState: initialGlobalState ?? getDefaultInitialApplicationState(),
                        dispatch: () => { }
                    } }
                >
                    <Router history={ history }>
                        <Route
                            exact={ true }
                            path={ path }
                            component={ ui }
                        />
                    </Router>

                </ApplicationContext.Provider>
            </ApplicationConfigContext.Provider>
        )
    };
}

export function renderWithApplicationContextAndDispatch(ui,
    {
        path = '/', // ie. '/project/:id'
        route = '/', // ie. '/project/ABC123'
        history = createMemoryHistory({ initialEntries: [route] }),
    } = {},
    initialGlobalState?: ApplicationState,
    initialAppConfig?: StandardAppConfig) {
    return {
        ...render(
            <ApplicationConfigContext.Provider value={ initialAppConfig ?? getDefaultBlankAppConfig() }>
                <ApplicationContextProvider initialState={ initialGlobalState ?? getDefaultInitialApplicationState() }>
                    <Router history={ history }>
                        <Route
                            exact={ true }
                            path={ path }
                            component={ ui }
                        />
                    </Router>
                </ApplicationContextProvider>
            </ApplicationConfigContext.Provider>
        )
    };
}
